module.exports = __webpack_public_path__ + "7b99cec250a4022c1b1655ded12c6a3c.png";